import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_DishDetails = _resolveComponent("DishDetails")!
  const _component_ReviewsComponent = _resolveComponent("ReviewsComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Dish Details",
      subTitle: "Restaurant"
    }),
    _createVNode(_component_DishDetails),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-4" }, null, -1)),
    _createVNode(_component_ReviewsComponent)
  ]))
}